<template>
  <div class="banner">
    <div class="banner-inner">
      <div class="logo" @click="$router.push({ name: 'home' })">
        <img src="@/assets/logo.png" alt="buybuy GENUINE" />
      </div>
      <div class="banner-content">
        <div class="banner-title">Genuine Parts of Chinese Car Brands</div>
        <div class="banner-desc">Fast and reliable worldwide delivery</div>
      </div>
      <div class="search-box">
        <el-input v-model="keyword" placeholder="Search by OE number" class="search-input"
          @keyup.enter.native="handleSearch" />
        <button class="search-btn" type="button" @click="handleSearch">
          <i class="el-icon-search"></i>
          <span>Search</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      keyword: "",
      banners: []
    };
  },
  mounted() {
    this.fetchBanners();
  },
  methods: {
    handleSearch() {
      this.$router.push({ name: "catalogue", query: { keyword: this.keyword } });
    },
    async fetchBanners() {
      try {
        const res = await this.$api({
          url: "Content/home",
          method: "get"
        });
        this.banners = (res && res.data && res.data.banners) || [];
      } catch (err) {
        console.error("Failed to fetch banners:", err);
      }
    }
  }
};
</script>

<style scoped>
.banner {
  width: 100%;
  background-color: #fff;
  padding: 18px 20px 28px;
}

.banner-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.logo {
  height: 48px;
  display: flex;
  align-items: flex-start;
}

.logo img {
  width: 114px;
  height: auto;
  display: block;
}

.banner-content {
  margin-top: 4px;
  text-align: center;
}

.banner-title {
  font-family: inherit;
  font-weight: 400;
  font-size: 40px;
  color: #000000;
  line-height: 56px;
  text-align: center;
  font-style: normal;
}

.banner-desc {
  font-family: inherit;
  font-weight: 400;
  font-size: 20px;
  color: #282828;
  line-height: 28px;
  text-align: center;
  font-style: normal;
}

.search-box {
  margin-top: 26px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  flex: 1;
}

.search-input ::v-deep .el-input__inner {
  height: 60px;
  padding: 0 20px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  color: #333;
  font-size: 15px;
  outline: none;
}

.search-input ::v-deep .el-input__inner::placeholder {
  color: #aaa;
}

.search-input ::v-deep .el-input__inner:focus {
  border-color: #ff5a1f;
}

.search-btn {
  width: 160px;
  height: 60px;
  border: 0;
  border-radius: 5px;
  background-color: #ff5a1f;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
}

.search-btn i {
  font-size: 22px;
  font-weight: 700;
}

.search-btn:hover {
  background-color: #f04e12;
}

@media (max-width: 768px) {
  .banner-title {
    font-size: 26px;
  }

  .search-box {
    flex-direction: column;
    align-items: stretch;
  }

  .search-btn {
    width: 100%;
  }
}
</style>
